<template>
  <img
    v-if="channelIconMap[channelType] === 'whatsapp'"
    :src="whatsAppLogo"
    :width="size"
    :height="size"
  />
  <img
    v-else-if="channelIconMap[channelType] === 'facebook'"
    :src="facebookLogo"
    :width="size"
    :height="size"
  />
  <img
    v-else-if="channelIconMap[channelType] === 'instagram'"
    :src="instagramLogo"
    :width="size"
    :height="size"
  />
  <widget-icon
    v-else
    :name="channelIconMap[channelType] as WidgetIconName"
    :size="size"
  />
</template>

<script setup lang="ts">
import type { WidgetIconName } from '@widgets/shared/icons/icons'
import WidgetIcon from '@widgets/shared/components/WidgetIcon.vue'
import { channelIconMap } from '@/components/domain/messages/settings/webWidget/const'
import whatsAppLogo from '@/assets/images/whatsapp.svg'
import facebookLogo from '@/assets/images/facebook.svg'
import instagramLogo from '@/assets/images/social/instagram.svg'
import type { WebWidgetChannelType } from '@/data/models/domain/messages/settings/webWidget/types'

const { channelType, size = '16px' } = defineProps<{
  channelType: WebWidgetChannelType
  size: string
}>()
</script>
